module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_j_piebald.fc8fced7.png";